import styled from 'styled-components';
import { BannerBackgroundImgDiv, BannerBackgroundImg } from '../shared/BannerBackgroundImgDiv';
import { makeExternalUrl } from '../../../../lib/utils';

const HeroBannerBackgroundImgDiv = styled(BannerBackgroundImgDiv)`
  max-width: none;
  width: 100%;
`;

const HeroBannerBackgroundImg = styled(BannerBackgroundImg)`
  max-width: none;
  width: 100%;
  position: absolute;
  object-fit: cover;
`;

const CenteredColumnDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;  
`;

const TextOverlayH1 = styled.h1`
  ${({ theme }) => theme.typographyRebrand.heading['3xl']}
  z-index: ${p => p.theme.elevation[0]};
  text-transform: uppercase;
  color: ${p => (p.fontColor ? p.fontColor : p.theme.c.text.primary)};
  margin: 0 ${p => p.theme.unit(5)};
  text-align: center;
`;

const DesktopTextOverlayH1 = styled(TextOverlayH1)`
  margin-bottom: ${p => p.theme.unit(2)};
`;

const HeroSubtextDiv = styled.div`
  ${({ theme }) => theme.typographyRebrand.heading['xl']}
  color: ${p => (p.fontColor ? p.fontColor : p.theme.c.text.primary)};
`;

const SeasonalHeroBanner = (props) => {
  const {
    seasonalPageData = {},
    isMobile = false,
  } = props;

  const {
    heroImageUrl = '',
    heroText = '',
    heroAltText = '',
    heroFontColor = '',
    heroSubtext = '',
  } = seasonalPageData;

  const externalHeroImageUrl = makeExternalUrl(heroImageUrl);

  return (
    <HeroBannerBackgroundImgDiv>
      <HeroBannerBackgroundImg src={externalHeroImageUrl} alt={heroAltText} />
      <CenteredColumnDiv>
        <DesktopTextOverlayH1 fontColor={heroFontColor} >
          {heroText}
        </DesktopTextOverlayH1>
        <HeroSubtextDiv fontColor={heroFontColor}>
          {heroSubtext}
        </HeroSubtextDiv>
      </CenteredColumnDiv>
    </HeroBannerBackgroundImgDiv>
  );
};

export default SeasonalHeroBanner;
